import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }